import { TextField } from "@mui/material";
import React, { useRef, useEffect } from "react";

interface Props {
  value: string;
  error: boolean;
  onChange: (value: string) => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const CategoryNameField: React.FC<Props> = ({ value, error, onChange, onKeyPress }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const cursorPositionRef = useRef<number | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target;
    cursorPositionRef.current = input.selectionStart;
    onChange(e.target.value);
  };

  useEffect(() => {
    if (inputRef.current && cursorPositionRef.current !== null) {
      const input = inputRef.current;
      setTimeout(() => { input.setSelectionRange(cursorPositionRef.current, cursorPositionRef.current); }, 0);
    }
  }, [value]);

  return (
    <TextField
      inputRef={inputRef}
      label={
        <span>
          Category name <span style={{ color: "#f04141", fontSize: "15px" }}>*</span>
        </span>
      }
      id="Category_Name"
      value={value}
      onChange={handleChange}
      onKeyPress={onKeyPress}
      error={error}
      fullWidth
    />
  );
};

export default CategoryNameField;
